angular.module('qkr.coupon').filter('outletFilter', () => function(coupons, selectedOutlet) {
    if (coupons && selectedOutlet) {
        return coupons.filter( coupon =>  coupon.applicableLocations.length === 0 ||
            coupon.applicableLocations.indexOf(selectedOutlet) !== -1)
    }

    return coupons;
});


// WEBPACK FOOTER //
// ./src/coupons/filters/qkr.coupon.js